export { default as ViewGridSmIcon } from './ViewGridSmIcon';
